import {Props} from '@peachy/utility-kit-pure'
import {PaymentEvent} from './PaymentEvent'


export class MrPaymentFailed extends PaymentEvent {
    constructor(from: Props<MrPaymentFailed>) {
        super(from)
    }
}
